<!-- =========================================================================================
  File Name: BoardEdit.vue
  Description: Board Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="page-archive-edit">

    <vs-alert color="danger" title="Board Not Found" :active.sync="board_not_found">
      <span>Board record with boardEntrySeq: {{ $route.params.boardEntrySeq }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'page-archive-list'}" class="text-inherit underline">All Users</router-link>
      </span>
    </vs-alert>

    <vx-card title="자료실 상세" class="mb-base" v-if="board_data">
      <archive-edit-form class="mt-4" :data="board_data" />
    </vx-card>

  </div>
</template>

<script>
import ArchiveEditForm  from './ArchiveEditForm.vue'
import { fetchData } from '@/api/module'

export default {
  components: {
    ArchiveEditForm
  },
  data () {
    return {
      boardEntrySeq: this.$route.params.boardEntrySeq,
      board_data: null,
      board_not_found: false
    }
  },
  methods : {
    async fetch_board_data () {
      try {
        const { data } = await fetchData(`board/${this.boardEntrySeq}`)
        this.board_data = data.data
        console.log(JSON.stringify(this.board_data))

      } catch (error) {

        this.$vs.notify({
          title: 'Error',
          text: error.response.data.msg,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          color: 'danger'
        }) 
      }
    }
  },
  created () {
    this.fetch_board_data()
  } 
}

</script>
